import { Box, Skeleton } from "@mui/material";
import { SubscriptionContainer } from "./styles";

export const SubscriptionFlowSkeleton = () => {
  return (
    <SubscriptionContainer>
      <Box sx={{ width: "100%", marginBottom: 6 }}>
        <Skeleton variant="rounded" sx={{ width: "100%", height: 32 }} />
      </Box>

      <Skeleton variant="rounded" sx={{ width: "100%", height: 480 }} />
    </SubscriptionContainer>
  );
};
